module.exports = "<div class=child-filters-wrap> <div>{%= filterList %}</div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/WidgetEngine/html/filterHtml/childFiltersWrap.html
// module id = 1123
// module chunks = 1